<div class="mb-6 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@breadcrumbBundles">Bundles</h1>
  <a
    [routerLink]="['/admin/bundles/create-bundle']"
    class="bgTabsColor flex cursor-pointer items-center gap-1 rounded-lg px-4 py-2 text-sm text-white"
    *hasScope="SCOPES.BUNDLES.ADD">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
    </svg>
    <span i18n="@@addBundle">Add Bundle</span>
  </a>
</div>

<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-bundle-filters-component
    [filters]="filters()"
    (applyFilters)="applyFilters()"
    (resetFilters)="resetFilters()"
    (toggleSortOrder)="handleToggleSort()" />

  <app-bundle-table-component
    [bundles]="bundles()"
    [state]="state()"
    [errorMessage]="error()"
    [isFiltersApplied]="isFilterApplied()"
    (retry)="loadBundles()"
    (viewBundle)="navigateToView($event)"
    (editBundle)="navigateToEdit($event)"
    (activateBundle)="openActivationModal($event, 'activate')"
    (deactivateBundle)="openActivationModal($event, 'deactivate')"
    (deleteBundle)="openDeleteModal($event)" />
</div>

@if (state() === "success") {
  <app-pagination
    [itemsPerPage]="pageSize()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="goToPage(currentPage() - 1)"
    (nextPage)="goToPage(currentPage() + 1)"
    (goToPage)="goToPage($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (deleteModal()) {
  <app-confirmation-dialog
    layout="start"
    [title]="isArabic() ? 'حذف الباقة؟' : 'Delete Bundle?'"
    [description]="
      (isArabic() ? 'هل أنت متأكد من حذف ' : 'Are you sure you want to delete ') +
      (isArabic() ? bundleToDelete()?.titleAr : bundleToDelete()?.titleEn) +
      '?'
    "
    [confirmContent]="isArabic() ? 'حذف' : 'Delete'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    [isLoading]="loadingDelete()"
    [error]="errorDelete()"
    (onSubmit)="confirmDelete()"
    (onCancel)="closeDeleteModal()" />
}

@if (confirmationModal()) {
  <app-confirmation-dialog
    layout="start"
    [title]="
      activationType() === 'activate'
        ? isArabic()
          ? 'تفعيل الباقة؟'
          : 'Activate Bundle?'
        : isArabic()
          ? 'إلغاء تفعيل الباقة؟'
          : 'Deactivate Bundle?'
    "
    [description]="
      (activationType() === 'activate'
        ? isArabic()
          ? 'هل أنت متأكد من تفعيل '
          : 'Are you sure you want to activate '
        : isArabic()
          ? 'هل أنت متأكد من إلغاء تفعيل '
          : 'Are you sure you want to deactivate ') +
      (isArabic() ? bundleToActivate()?.titleAr : bundleToActivate()?.titleEn) +
      '?'
    "
    [confirmContent]="
      activationType() === 'activate' ? (isArabic() ? 'تفعيل' : 'Activate') : isArabic() ? 'إلغاء التفعيل' : 'Deactivate'
    "
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    [isLoading]="loadingActivation()"
    [error]="errorActivation()"
    (onSubmit)="confirmActivation()"
    (onCancel)="closeActivationModal()" />
}

@if (deleteSuccess()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم حذف الباقة بنجاح.' : 'Bundle deleted successfully.'" />
}

@if (activationSuccess()) {
  <app-successful-notification
    type="success"
    [title]="
      activationType() === 'activate'
        ? isArabic()
          ? 'تم تفعيل الباقة بنجاح.'
          : 'Bundle activated successfully.'
        : isArabic()
          ? 'تم إلغاء تفعيل الباقة بنجاح.'
          : 'Bundle deactivated successfully.'
    " />
}
